<template>
    <div class="admin-operations">
        <app-header />
        <sub-header title="admin_operations" />
        <admin-operations-main-body />
    </div>
</template>

<script>
import BackendProvider from '../../business/services/BackendProvider'
import AppHeader from '../components/Header'
import AdminOperationsMainBody from '../components/admin-operations/AdminOperationsMainBody'
import SubHeader from '../components/common/SubHeader'

export default {
    name: 'AdminOperations',
    components: { AppHeader, AdminOperationsMainBody, SubHeader },
    computed: {
        isAdminEmployee() {
            return BackendProvider.isAdminEmployee()
        }
    },
    mounted() {
        if (!this.isAdminEmployee) {
            this.$store.dispatch('navigation/navigateHome')
        }
    }
}
</script>
